import { MdWork } from "react-icons/md";
import Container from "./../Components/Container";
import { work_xp } from "../Inc/data";

export default function WorkExperience() {
  return (
  <section id="work-xp" className="bg-white min-h-[calc(100vh-70px)] snap-start">
      <Container transparent outterPadding="mt-10" innerPadding="pt-6">
        <div className="flex flex-col justify-center items-center">
          <div className="text-sky-800 font-extrabold">Experience</div>
          <div className="text-2xl font-semibold">Work Experience</div>
          <div className="h-1 bg-sky-800 w-36 my-2"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
          <div className="bg-white border shadow-sm rounded-lg ps-6 p-2">
            <ol className="relative border-s border-gray-200">
          {work_xp.filter((_,i) => i < 3).map((_, i) => (
            <li key={`work-xp${i}`} className="my-10 ms-6">
              <span className="absolute flex items-center justify-center w-6 h-6 bg-sky-800 rounded-full -start-3 ring-8 ring-white">
                <MdWork className="text-white text-xs" />
              </span>
              <h3 className="text-lg font-semibold text-gray-900 ">
                {_.title}
              </h3>
              <div className="block mb-2 text-sm font-normal leading-none">
              {_.company}
              </div>
              <time className="block mb-2 text-sm font-normal leading-none text-gray-400 ">
                {_.start_date} to {_.end_date ? _.end_date : "Present"}.
              </time>
              <ul className="space-y-1 text-gray-500 list-disc list-inside">
                {_.duties.map((duty, index) => <li key={`duty-${index}`}>{duty}</li>)}
              </ul>
            </li>
          ))}
        </ol>
          </div>
        <div className="bg-white border shadow-sm rounded-lg ps-6 p-2">
          <ol className="relative border-s border-gray-200">
          {work_xp.filter((_,i) => i >= 3).map((_, i) => (
            <li key={`work-xp${i}`} className="my-10 ms-6">
              <span className="absolute flex items-center justify-center w-6 h-6 bg-sky-800 rounded-full -start-3 ring-8 ring-white">
                <MdWork className="text-white text-xs" />
              </span>
              <h3 className="text-lg font-semibold text-gray-900 ">
                {_.title}
              </h3>
              <div className="block mb-2 text-sm font-normal leading-none">
              {_.company}
              </div>
              <time className="block mb-2 text-sm font-normal leading-none text-gray-400 ">
                {_.start_date} to {_.end_date ? _.end_date : "Present"}.
              </time>
              <ul className="space-y-1 text-gray-500 list-disc list-inside">
                {_.duties.map((duty, index) => <li key={`duty-${index}`}>{duty}</li>)}
              </ul>
            </li>
          ))}
        </ol>
        </div>
        </div>
      </Container>
    </section>
  );
}
